module.exports = __webpack_public_path__ + "static/media/48362815_2309078819167296_3794263500440731648_o.2b1c60d7.jpg";